module.exports = __webpack_public_path__ + "img/zepto.b1ef6aab.png";